import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-data" }
const _hoisted_2 = { class: "group-name" }
const _hoisted_3 = { class: "group-item" }

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import { maskCurrency } from "@/common/utils/mask";

import type { ServiceType, ServicePayloadType } from "@/common/types/service";

import { baseInput, baseTextEditor, baseSelect } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-service',
  props: {
    data: {},
    isPatch: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["update:data", "validate"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  active: true,
  free: false,
  price: 0,
  name: "",
  currency: "BRL",
  description: null,
};

const payload = ref<ServicePayloadType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

const isValid = ref(false);

const activeOptions = computed(() => [
  { option: t("common.labels.active"), value: true },
  { option: t("common.labels.inactive"), value: false },
]);

const freeOptions = computed(() => [
  { option: t("common.labels.yes"), value: true },
  { option: t("common.labels.not"), value: false },
]);

const currencyOptions = computed(() =>
  Object.entries(tm("enums.currencies") as Record<string, string>).map(
    ([value, option]) => ({
      option,
      value,
    })
  )
);

function validate() {
  let free = ["description"];

  if (payload.value.free) {
    payload.value.price = 0;
    free.push("price");
    free.push("currency");
  } else {
    free = ["description"];
  }

  Object.keys(payload.value).forEach((key) => {
    delete errors.value[key];

    if (
      (payload.value[key] === null ||
        payload.value[key] === "" ||
        payload.value[key] === undefined) &&
      !free.includes(key)
    )
      errors.value[key] = t("error.required");
  });

  isValid.value = Object.keys(errors.value).length === 0;
}

function maskMoney(data: string) {
  return maskCurrency(data, payload.value.currency as any);
}

function update(key: keyof typeof payload.value) {
  validate();

  if (props.isPatch) {
    if (payload.value[key] === props.data[key]) return;

    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);

  setTimeout(() => emit("validate", isValid.value), 50);
}

function changeCurrency() {
  payload.value.price = maskMoney(payload.value.price as any) as any;

  emit("update:data", {
    price: payload.value.price,
    currency: payload.value.currency,
  });
}

function resumeData() {
  if (!props.data) return;

  const {
    active,
    free,
    price: priceDecimal,
    currency,
    name,
    description,
  } = props.data;

  const priceFloat = Number.parseFloat(priceDecimal?.toString()).toFixed(2);
  const priceString = maskCurrency(priceFloat, currency as any);

  payload.value = {
    ...payload.value,
    active,
    free,
    price: priceString as any,
    currency,
    name,
    description,
  };
}

watch(
  () => props.data,
  () => {
    resumeData();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        required: "",
        maxlength: "150",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (update('name')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.name)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.name), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.active,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.active) = $event)),
        value: payload.value.active,
        options: activeOptions.value,
        "is-empty": false,
        onChange: _cache[3] || (_cache[3] = ($event: any) => (update('active')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.active")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.free,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.free) = $event)),
        value: payload.value.free,
        options: freeOptions.value,
        "is-empty": false,
        onChange: _cache[5] || (_cache[5] = ($event: any) => (update('free')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.free")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.currency,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.currency) = $event)),
        value: payload.value.currency,
        options: currencyOptions.value,
        disabled: payload.value.free,
        "is-empty": false,
        onChange: _cache[7] || (_cache[7] = ($event: any) => (changeCurrency()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.currency")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options", "disabled"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.price,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.price) = $event)),
        value: payload.value.price,
        mask: maskMoney,
        disabled: payload.value.free,
        onBlur: _cache[9] || (_cache[9] = ($event: any) => (update('price')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.price")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.price)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.price), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "disabled"])
    ]),
    _createVNode(_unref(baseTextEditor), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": [
        _cache[10] || (_cache[10] = ($event: any) => ((payload.value.description) = $event)),
        _cache[11] || (_cache[11] = ($event: any) => (update('description')))
      ]
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("category.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})